import { computed, Ref, ref, watch } from 'vue';

export const useCountdownTimer = (milliseconds: Readonly<Ref<number>>, interval = 1000) => {
  const timeLeft = ref(milliseconds.value);
  const timePassed = ref(0);
  const timer = ref<NodeJS.Timeout | null>(null);

  const start = () => {
    resetAndStop();
    timer.value = setInterval(() => {
      timeLeft.value -= interval;
      timePassed.value += interval;
    }, interval);
  };

  const stop = () => {
    if (timer.value) clearInterval(timer.value);
  };

  const reset = () => {
    timeLeft.value = milliseconds.value;
    timePassed.value = 0;
  };

  const resetAndStop = () => {
    reset();
    stop();
  };

  const restart = () => {
    stop();
    start();
  };

  const expired = computed(() => timeLeft.value <= 0);

  watch(expired, (isExpired) => {
    if (isExpired) {
      stop();
    }
  });

  watch(milliseconds, () => {
    resetAndStop();
    console.info('milliseconds changed, resetting timer and stopping it');
  });

  return {
    timeLeft,
    timePassed,
    start,
    stop,
    restart,
    reset,
    resetAndStop,
    expired,
  };
};
